import { rubIcon } from "../../../../shared/assets/svg/rubIcon";
import { Stack } from "../../../../shared/ui/Stack/Stack";
import { Text } from "../../../../shared/ui/Text/Text";
import { EsteticPriceData } from "../lib/data";
import styles from './EsteticPrice.module.scss';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 


const EsteticPrice = () => {
    useGSAP(() => {
        gsap.to(".esteticPrice", { "--opacity": 1, 
                                    "--x": "0px",
                                    y:-10,  
                                    duration: 1, 
                                    scrollTrigger: {
                                        trigger: ".esteticPrice"
        }});
    }, [])

    return (  
        <div className={styles.container}>
            <Stack     
                    justifyContent = 'justifyCenter'                    
            >
                <Text type="h2" size='l' className={`esteticPrice ${styles.title}`}>
                    СТОИМОСТЬ УСЛУГ
                </Text>    
            </Stack>
            {EsteticPriceData.map(element => 
                <Stack
                    gap='32'
                    justifyContent = 'justifyBetween' 
                    alignItems ='alignEnd'           
                    className={styles.priceContent}
                    key={element.id}
                >

                    <Text  size='m' className={styles.text}>
                        {element.service}
                    </Text>  
                    <Text  size='m' className={styles.text}>
                        {element.price} {rubIcon()}
                    </Text>    
                </Stack>
            )}
        </div>
    );
}
export default EsteticPrice;